import { SelectOption } from '@shape-ds/components';
import SapNoteStatus from 'components/SapNotesStatus/SapNoteStatus';
import { TEMPLATES } from 'config/constants';
import { useGetOptions } from 'queries/cases/queries';
import { SapNoteCriticalLevel } from 'queries/externalReferences/contract';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInput, FormSelect } from 'ui/FormComponents';
import './ExternalReference.scss';

interface Props {
  index?: number;
  isDisabled?: boolean;
}

const caseActionsOptions = {
  external_reference_type: [] as string[],
};

export function ExternalReference({ index, isDisabled }: Props) {
  const { t } = useTranslation();

  const { data } = useGetOptions(TEMPLATES.CASE_ACTIONS, caseActionsOptions) || {};
  const fieldName = index !== undefined ? `actions.${index}.` : '';
  const external_referenceData = useWatch({
    name: fieldName + 'external_reference',
  });

  const external_reference = external_referenceData ?? {
    status: '',
    code: '',
    type: '',
  };

  const status = external_reference.status || 'offline';
  const code = external_reference.code || '';
  const type = external_reference.type;

  const selectOptions: SelectOption[] = useMemo(
    () =>
      data?.external_reference_type?.map((item) => ({
        label: t(`components:external_reference.type.${item}`, { defaultValue: item }),
        value: item,
      })) || [],
    [data?.external_reference_type, t],
  );
  return (
    <>
      <FormSelect
        label={t('components:external_reference.type_label')}
        name={`${fieldName}external_reference.type`}
        placeHolderText={t('components:external_reference.placeholders.selectReference')}
        selectOptionData={selectOptions}
        disabled={isDisabled}
        data-testid="external-reference-type"
      />

      <FormInput
        placeHolderText={type ? t('components:external_reference.placeholders.code') : ''}
        label={t('components:external_reference.code_label')}
        name={`${fieldName}external_reference.code`}
        disabled={isDisabled || !type}
        data-testid="external-reference-code"
        classname="external-reference-code"
        type="text"
        icon={
          code && (
            <SapNoteStatus
              tooltipOnStatus={{
                title: t(`conditionDeviation:sap_note_status.${status?.toLowerCase()}`),
              }}
              status={status as SapNoteCriticalLevel}
              code={code}
              showCode={false}
            />
          )
        }
      />
    </>
  );
}
